"use strict";
var Observable_1 = require('../../Observable');
var throttle_1 = require('../../operator/throttle');
Observable_1.Observable.prototype.throttle = throttle_1.throttle;
//# sourceMappingURL=throttle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/throttle.js
// module id = 1205
// module chunks = 0